'use client';

import { GlobalErrorContent } from '@vs-shop/rcprofi/host/errorBoundary';

export default function Error({ error }: { error: Error & { digest?: string } }) {
  return <GlobalErrorContent error={error} />;
}
